module.exports = __webpack_public_path__ + "static/img/zn_no.1.d002ae2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zn_no.1.jpg
// module id = bgJ6
// module chunks = 17